import { type FC } from 'react';

import type {
  DashboardWidgetProps,
  WidgetChartConfigCamelizedDefault,
} from 'src/types/dashboard';
import { apiPaths } from 'src/services/api/apiPaths';
import BaseTrendAnalysisWidget from 'src/components/dashboard/DashboardPage/components/BaseWidget/TrendAnalysisWidget';

const TrendAnalysisResponseRateWidget: FC<DashboardWidgetProps> = ({
  config,
}) => {
  const chartConfigDefault: WidgetChartConfigCamelizedDefault = {
    yAxisMax: 100,
    yAxisMin: 0,
    yAxisStepSize: 25,
  };
  return (
    <BaseTrendAnalysisWidget
      config={config}
      endpointPath={apiPaths.WIDGET_DATA.TREND_ANALYSIS_RESPONSE_RATE}
      chartConfigDefault={chartConfigDefault}
    />
  );
};
export default TrendAnalysisResponseRateWidget;
